export const Form = (function ($) {
  "use strict";

  /* =================== public methods ================== */

  // main init method
  function Init() {
    //console.log("boilerplate module init");
    $(".blog-entry-reply form").submit(function (e) {
      $("#comment-form-name-new").val(
        $("#comment-form-firstname-new").val() +
          " " +
          $("#comment-form-lastname-new").val()
      );
    });
  }

  /* =============== export public methods =============== */
  return {
    Init: Init,
  };
})(jQuery);
